(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["as-wallpaper-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('as-wallpaper-details')) {
    customElements.define('as-wallpaper-details', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const source = this.querySelector('[data-original]');
        if (!source) return;
        const buckets = { description: [], material: [], measurements: [], installation: [], shipping: [], rights: [] };
        const normalize = text => text.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
        const units = [];
        const collect = node => {
          if (node.nodeType === Node.TEXT_NODE) {
            if (node.textContent.trim()) { const p = document.createElement('p'); p.textContent = node.textContent; units.push(p); }
            return;
          }
          if (node.nodeType !== Node.ELEMENT_NODE || ['META', 'STYLE', 'SCRIPT'].includes(node.tagName)) return;
          if (['DIV', 'SECTION', 'ARTICLE'].includes(node.tagName)) { Array.from(node.childNodes).forEach(collect); return; }
          if (normalize(node.textContent) || node.querySelector('img') || node.tagName === 'IMG') units.push(node.cloneNode(true));
        };
        Array.from(source.childNodes).forEach(collect);
        let section = 'description';
        for (const node of units) {
          const text = normalize(node.textContent);
          if ((text.startsWith('venta por m²') || text.startsWith('venta por m2')) && text.includes('instalación:')) {
            const index = node.textContent.toLowerCase().indexOf('instalación:');
            const measurements = document.createElement('p'); measurements.textContent = node.textContent.slice(0, index).trim();
            const installation = document.createElement('p'); installation.textContent = node.textContent.slice(index).trim();
            buckets.measurements.push(measurements); buckets.installation.push(installation);
            continue;
          }
          let target = section;
          if (text.startsWith('todos los derechos')) target = 'rights';
          else if (text.includes('una vez instalado') || text.includes('listado de instaladores') || text.startsWith('instalación:')) target = 'installation';
          else if (text.startsWith('para pedidos') || text.startsWith('consultas:')) target = 'shipping';
          else if (text.startsWith('envíos') || text.startsWith('envios')) { section = 'shipping'; target = section; }
          else if (text.startsWith('tipo de papel') || text.startsWith('características') || text.startsWith('caracteristicas')) { section = 'material'; target = section; }
          else if (text.startsWith('valor papel por m2') || text.startsWith('venta por m²') || text.startsWith('venta por m2')) target = 'measurements';
          else if (text.startsWith('las fotos son referenciales') || text.startsWith('los colores pueden')) target = 'material';
          else if (text.startsWith('colección') || text.startsWith('coleccion')) target = 'description';
          if (/^(tipo de papel|características|caracteristicas|envíos|envios)\s*:?\s*$/.test(text)) continue;
          node.removeAttribute('style');
          node.querySelectorAll('[style]').forEach(child => child.removeAttribute('style'));
          buckets[target].push(node);
        }
        if (this.dataset.note) { const p = document.createElement('p'); p.textContent = this.dataset.note; buckets.measurements.push(p); }
        const fragment = document.createDocumentFragment();
        const titles = { description: this.querySelector('summary').textContent, material: this.dataset.material, measurements: this.dataset.measurements, installation: this.dataset.installation, shipping: this.dataset.shipping };
        for (const [key, title] of Object.entries(titles)) {
          if (!buckets[key].length) continue;
          const details = document.createElement('details'); details.className = 'disclosure product-info-accordion';
          const summary = document.createElement('summary'); summary.className = 'disclosure__title'; summary.textContent = title;
          const content = document.createElement('div'); content.className = 'disclosure__content rte'; content.append(...buckets[key]);
          details.append(summary, content); fragment.append(details);
        }
        if (buckets.rights.length) { const rights = document.createElement('div'); rights.className = 'as-wallpaper-rights'; rights.append(...buckets.rights); fragment.append(rights); }
        this.replaceChildren(fragment);
        this.dataset.ready = 'true';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
